import { User } from "."
import { smeType } from "./sme"
import { LabeledValueWithFieldInfo, UserIdWithStatusAndFields, UserWithFieldInfo, UserWithFields } from "./user"

export interface Assignment {
	caseId: string
	caseNumber: string
	hours: number
	fieldId: string
	fieldSMEType: smeType | null
}

export interface UserTime {
	id: string
	userId: string
	tenantId: string
	date: string
	capacityTotal: number
	capacityRemaining: number
	assignments: Assignment[]
}

export interface UserTimeForWeek {
	userId: string;
	assignmentCountInWeek: number;
	assignmentCountForDate: number;
	weeklyRemainingCapacity: number;
	assignmentDateRemainingCapacity: number;
	shiftPatterns?: ShiftPatternInfo[];
}

export interface UserTimeForWeekWithUser extends UserTimeForWeek {
	user: UserWithFields;
}

export interface TimeManagementSettingsWithShiftPatterns extends TimeManagementSettings {
	shiftPatterns?: ShiftPattern[]
}

export interface TimeManagementSettings {
  id: string | null
  tenantId: string | null
  enabled: boolean
  assignmentDateFieldId: string | null
  shareHours: boolean
  overflowHours: boolean
  defaultHoursWhenUnset: number | null
  userFilterFields: UserFilterField[]
  excludeFromAvailable: { [userFieldId: string]: string[] }
}

export interface ShiftPattern {
    id: string | null
    title: string
    durationHours: number
	color?: string
}

export interface ShiftPatternInfo {
	title: string
	date: string
}

export interface UserFilterField {
  userField: string
  recordField: string
}

export interface DisplayUserTime extends UserTimeForWeek {
	userId: string
	name: string
	user: UserWithFieldInfo
}

export interface UserSchedule {
	userId: string,
	name: string,
	userFieldInfo: { [key: string]: LabeledValueWithFieldInfo },
	assignmentDays: { [key: string]: UserTime },
	_rowVariant?: string
}

export interface GroupedUserSchedules {
	key: string,
	label: string,
	userSchedules: UserSchedule[],
	totalsRows: TotalsRow[]
}

export enum TotalType {
	TotalUsers = "totalUsers",
	TotalScheduledHours = "totalScheduledHours",
	RequiredUsers = "requiredUsers",
	TotalHours = "totalHours"
}

export interface TotalsRow {
	key: string,
	type: TotalType,
	title: string,
	icon: string,
	values: { [key: string]: {
		value: number,
		warning?: boolean,
		assignmentDays?: UserTime[]
	}}
}

export enum AvailabilityRange {
	OnDate,
	WeekOf
}

export enum AssignmentMergeType {
	Merge = "merge",
	Replace = "replace",
	ReplaceForFields = "replaceForFields"
}
